import store from '../store';

const getLocalUserData = () => {
  return {
    'locale': 'ko-KR',
    'now': '2018-10-10T14:03:16.750+09:00',
    'site': store('game'),
    'guid': '',
    'uesAccountType': 'gameAccount',
    'ncAccount': {
      'name': '',
      'profileImage': '',
      'url': '',
      'target': ''
    },
    'gameAccount': {
      'name': '',
      'profileImage': '',
      'url': '',
      'subData': [
        {title: 'server', value: '', url: ''},
        {title: 'level', value: '', url: ''},
        {title: 'race', value: '', url: ''},
        {title: 'job', value: '', url: ''}
      ]
    },
    'nshop': {
      'nCoin': '0',
      'coupon': '0'
    },
    'login': false,
    'accountState': []
  };

};

export default getLocalUserData;
